<template>
	<input
		class="date text-center"
		:value="value"
		type="date"
		min="1970-01-02"
		max="2038-01-18"
		@input="$emit('input', $event.target.value)"
	/>
</template>

<script>
	export default {
		name: 'InputDate',
		props: {
			value: String,
		},
	};
</script>
